/**
 * Timing name is used as facet path that must contain only letters, digits, or the characters - _ . @ $
 * based on node_modules/@datadog/browser-rum-core/src/domain/view/trackViews.ts
 */
export const sanitizeTiming = (name: string) => {
  const sanitized = name.replace(/[^a-zA-Z0-9-_.@$]/g, "_")
  return sanitized
}
